import { StepsComponent } from '../subject_update/StepsComponent'
import React from 'react'
import { Phase, SubjectType } from '../../../Types'

type Props = {
  phasesData: Phase[]
  subjectData: SubjectType
}
export const SubjectJourney = ({ phasesData, subjectData }: Props) => {
  return (
    <div className="row" style={{}}>
      <div className="col-12">
        <h5 className="font-weight-bold mb-3">Subject Journey</h5>
        <p className="opacity-75 mb-3">
          Review the subject's current phase and manage their progression through the study.
        </p>
      </div>

      <div className="col-12">
        <StepsComponent phasesData={phasesData} subjectData={subjectData} />
      </div>
    </div>
  )
}
